import styled from "styled-components";
import alertDangerIcon from "../../../Media/alert-danger-large.svg";
import { FlexColumnDiv, FlexRowDiv } from "../../common.styles";
import { HXDialogContent } from "../../HXDialog";
import { fontWeights } from "healthex-common/weights";
import { BaseLink } from "../../base.styles";
export const ConflictDialogIntroSection = styled(FlexRowDiv) `
    gap: 16px;
    align-items: center;
`;
export const ConflictDialogAlertImage = styled.img.attrs({ src: alertDangerIcon }) `
    width: 90px;
    height: 90px;
`;
export const ConflictDialogIntroText = styled.div ``;
export const ConflictDialogContent = styled(HXDialogContent) `
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
export const ConflictDialogComparison = styled(FlexColumnDiv) `
    gap: 16px;
`;
export const ConflictDialogValueSection = styled(FlexColumnDiv) ``;
export const ConflictSectionValueLabel = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const ConflictSectionValue = styled.div `
    white-space: pre-wrap;
`;
export const ConflictSectionPreviewableValue = styled(BaseLink) ``;
